// Shared between read-side consumers and MachineHourRateSettings inside Insights4.
export const MACHINE_HOUR_RATE_KEY = 'insightsMachineHourRate';

// machine_name alone identifies one rate entry - one hourly rate per machine.
export const rateKey = (row) => row.machine_name;
